export function createArrayFromTo(from: number, to: number) {
  const result: number[] = [];

  for (let i = from; i <= to; i++) {
    result.push(i);
  }

  return result;
}
